import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectSendStatus = createSelector(
  [(store: RootState) => store.fichaMiDt.sendStatus],
  (data) => data
);
